import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/states');
}
//Get all active
export function allActive(){
    return http().get('/states/active');
}
//Get Single
export function single(id){
    return http().get(`/states/${id}`);
}
//Add one
export function add(data){
    return http().post('/states', data)
}
//Update
export function update(id, data){
    return http().put(`/states/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/states/${id}`);
}